import { useLanguage } from "../context/LanguageContext";
import { Reveal } from "./motion";

export const FormatsSection = () => {
  const { t } = useLanguage();
  const f = t.formats;
  return (
    <section data-testid="formats-section" className="grain relative overflow-hidden bg-deep text-white">
      <div className="mx-auto max-w-[1600px] px-6 py-28 sm:px-12 sm:py-40 md:px-16">
        <Reveal y={14}>
          <p className="text-[13px] font-medium uppercase tracking-label text-wave">{f.label}</p>
        </Reveal>
        <Reveal delay={0.15}>
          <h2 className="font-head mt-8 max-w-3xl text-3xl leading-tight sm:text-5xl">{f.title}</h2>
        </Reveal>
        <div className="mt-20 grid gap-12 lg:grid-cols-3 lg:gap-0 lg:divide-x lg:divide-white/10">
          {f.items.map((item, i) => (
            <Reveal
              key={item.title}
              delay={i * 0.1}
              className="group lg:px-12 lg:first:pl-0 lg:last:pr-0"
              data-testid={`format-${i}`}
            >
              <span className="font-head inline-block text-lg text-wave transition-transform duration-700 group-hover:-translate-y-1">
                {String(i + 1).padStart(2, "0")}
              </span>
              <h3 className="font-head mt-6 text-2xl transition-colors duration-500 group-hover:text-wave sm:text-3xl">
                {item.title}
              </h3>
              <p className="mt-5 text-base font-light leading-relaxed text-white/65">{item.text}</p>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
